import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FeedbackContextProps {
  message: string;
  messageType: 'success'|'warning'|'error'|'info';
  showMessage: (message: string) => void;
  showErrorMessage: (message: string) => void;
  clearMessage: () => void;
}

const FeedbackContext = createContext<FeedbackContextProps>({
  message: '',
  messageType: 'info',
  showMessage: () => { },
  showErrorMessage: () => { },
  clearMessage: () => { },
});

export const useFeedbackContext = (): FeedbackContextProps =>
  useContext(FeedbackContext);

interface FeedbackProviderProps {
  children: ReactNode;
}

export const FeedbackProvider: React.FC<FeedbackProviderProps> = ({
  children,
}: FeedbackProviderProps) => {
  const [message, setMessage] = useState<string>('');
  const [messageType, setMessageType] = useState<string>('');

  const showMessage = (message: string): void => {
    setMessage(message);
    setMessageType('success');
  };

  const showErrorMessage = (message: string): void => {
    setMessage(message);
    setMessageType('error');
  };

  const clearMessage = (): void => {
    setMessage('');
  };

  const contextValue: FeedbackContextProps = {
    message,
    messageType: messageType as 'success'|'warning'|'error'|'info',
    showMessage,
    showErrorMessage,
    clearMessage,
  };

  return (
    <FeedbackContext.Provider value={contextValue}>
      {children}
    </FeedbackContext.Provider>
  );
};
